import { render, staticRenderFns } from "./SectionIframe.vue?vue&type=template&id=54dcfcb1&scoped=true&"
import script from "./SectionIframe.vue?vue&type=script&lang=ts&"
export * from "./SectionIframe.vue?vue&type=script&lang=ts&"
import style0 from "./SectionIframe.vue?vue&type=style&index=0&id=54dcfcb1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dcfcb1",
  null
  
)

export default component.exports